<template>
	<el-dialog title="分拨" :visible.sync="visible" :before-close='assignStateStateClose' width="1150px" :close-on-click-modal="false">
		<!-- 头部表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="goods.title" label="商品名称" :key="1" width="200"/>
			<el-table-column prop="goods.sku_value" label="规格" :key="2"/>
			<el-table-column prop="goods.unit" label="单位" :key="3" align="center"/>
			<el-table-column prop="goods_count" label="采购数量" :key="4" align="center"/>
			<el-table-column prop="validation_data.paid_count" label="实收数量" :key="5" align="center"/>
			<el-table-column prop="validation_data.giving_count" label="赠品数量" :key="6" align="center"/>
			<el-table-column label="总计数量" :key="7" align="center">
				<template slot-scope="scope">
					<span>{{scope.row.validation_data.paid_count+scope.row.validation_data.giving_count}}</span>
				</template>
			</el-table-column>
		</el-table>
		<!-- 有效期数组 -->
		<div class="dateView" v-for="(item,index) in overdue_time_list" :key="index">
			<div class="dateName">有效期{{index+1}}</div>
			<div class="dateItem">
				<div>{{FormatDate(item.overdue_time)}}</div>
				<div>数量: {{item.count}}</div>
				<div>使用次数: {{item.times}}</div>
			</div>
		</div>
		<!-- 有效期分拨 -->
		<el-table :data="storeTable" style="width: 100%">
			<el-table-column prop="shop_name" label="门店" :key="1" width="80"/>
			<el-table-column prop="procure_goods_count" label="所需采购数量" :key="2" align="center" width="120"/>
			<el-table-column prop="address" label="分拨数量" :key="3" width="120" align="center">
				<template slot-scope="scope">
					<span>{{scope.row.fenboNum}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="date" :key="3+item" v-for="(item,index) in step" :label="'有效期'+item" align="center">
				<template slot-scope="scope">
					<el-input-number v-model="scope.row.overdue_time_list[index].count" controls-position="right" :min="0" size="small" @change="handleFenboChange(scope)"></el-input-number>
				</template>
			</el-table-column>
		</el-table>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleAssignClick">确认分拨</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import {
		procureGoodsDistribution
	} from '@/api/purchaseApi.js'
	export default {
		props: {
			assignState: { //显示状态
				default: false
			},
			assignData: {
				default: {}
			},
			id: {
				default: ''
			}
		},
		data() {
			return {
				visible: true,
				tableData:[],  //表头表格数据
				storeTable:[], //分拨门店表格
				overdue_time_list:[],  //有效期数组
				step:0,  //有效期计数器
			};
		},
		created() {
			this.tableData = [this.assignData];
			console.log(this.tableData,'this.tabqqqleDatathis.tableDatathis.tableData');
			this.overdue_time_list = [...this.assignData.validation_data.overdue_time_list];  //有效期列表
			this.step = this.overdue_time_list.length;
			// console.log(this.overdue_time_list);
			let procurez_request_list = this.assignData.procurez_request_list;  //门店所需数量
			// console.log('门店',procurez_request_list)
		let storeArr = JSON.parse(JSON.stringify(this.$store.getters['shopList']))
			// console.log(procurez_request_list,storeArr)
			//添加门店所需采购数量
			for(let i = 0;i<storeArr.length;i++){
				//循环添加门店所需采购数量
				if(procurez_request_list != null){
					storeArr[i].procure_goods_count = '--'
					for(let j = 0;j<procurez_request_list.length;j++){
						if(procurez_request_list[j].company_info.shop_id == storeArr[i].shop_id){
							storeArr[i].procure_goods_count = procurez_request_list[j].procure_goods_count
						}
					}
				}else{
					storeArr[i].procure_goods_count = '--'
				}
				let dateArr = [];   //有效期数组
				let fenboNum = 0;
				//循环添加多少个有效期
				for(let k =0;k<this.overdue_time_list.length;k++){
					let dateObj = {     //初始化有效期对象
						overdue_time:'',
						count:0,
						times:this.overdue_time_list[k].times
					}
					dateArr[k]= dateObj;
					fenboNum += dateArr[k].count;
				}
				storeArr[i].overdue_time_list = dateArr;
				storeArr[i].fenboNum = fenboNum;
			}
			// console.log('重组门店',storeArr)
			this.storeTable = storeArr
			console.log(this.storeTable)
		},
		methods: {
			//确认分拨
			handleAssignClick(){
				// console.log(this.assignData)
				let allCount = (this.assignData.validation_data.paid_count + this.assignData.validation_data.giving_count);
				let paid_count = this.assignData.validation_data.paid_count;
				let giving_count = this.assignData.validation_data.giving_count;
				let storeCount = 0;
				for(let m = 0; m<this.storeTable.length; m++){
					//计算门店总数量
					for(let n = 0; n<this.storeTable[m].overdue_time_list.length;n++){
						storeCount += this.storeTable[m].overdue_time_list[n].count
					}
					for(let i = 0;i<this.overdue_time_list.length;i++){
						this.storeTable[m].overdue_time_list[i].overdue_time = this.overdue_time_list[i].overdue_time
					}
				}
				console.log(allCount)
				if(storeCount != (paid_count+giving_count)){
					this.$message({
						message:'分拨数量必须等于实收数量加赠品数量',
						type:'warning'
					})
					return
				}
				
				// console.log(this.storeTable)
				let storeArr = [];
				for(let j = 0; j<this.storeTable.length;j++){
					if(this.storeTable[j].fenboNum > 0){
						storeArr[j]= this.storeTable[j]
					}
				}
				let shop_count = [...storeArr];
				shop_count = shop_count.filter(item => item);
				console.log(shop_count);
				for(let k = 0;k<shop_count.length;k++){
					shop_count[k].company_info = {
						company_id:'5e9412e0b2bfbc030160bdd5',
						company_name:'河南花生宠物医院有限公司',
						shop_id:shop_count[k].shop_id,
						shop_name:shop_count[k].shop_name
					}
				}
				for(let a = 0;a<shop_count.length;a++){
					delete shop_count[a].fenboNum;
					delete shop_count[a].procure_goods_count;
					delete shop_count[a].shop_id;
					delete shop_count[a].shop_name;
				}
				console.log('有数量的门店',shop_count);
				
				let parmars = {
					id:this.id,
					procure_goods_id:this.assignData.procure_goods_id,
					shop_count:shop_count,
				}
				console.log(parmars)
				procureGoodsDistribution(parmars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message:'分拨成功',
							type:'success'
						})
						this.$emit("refresh", false);
					}
				})
			},
			//计算分拨数量
			handleFenboChange(scope){
				// console.log(scope);
				let num = 0;
				for(let i = 0;i<scope.row.overdue_time_list.length;i++){
					num += scope.row.overdue_time_list[i].count;
				}
				this.$set(this.storeTable[scope.$index],['fenboNum'],num);
			},
			//向父组件发射关闭弹框
			assignStateStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
			//重构日期
			FormatDate(item){
				let time = new Date(item*1000) 
				let year = time.getFullYear()
				let month = time.getMonth() + 1<10?'0'+(time.getMonth() + 1):time.getMonth() + 1
				let date = time.getDate()<10?'0'+time.getDate():time.getDate()
				return year+'-'+month+'-'+date
			},
		},
		watch: {
			// 监视状态发生改变
			assignState() {
				this.visible = this.assignState;
			},
		}
	}
</script>
<style lang="scss" scoped>
	.dateView{
		display: flex;
		line-height: 54px;
		font-size: 16px;
		color: #2A2A2A;
		align-items: center;
		border-bottom: solid 1px #F5F5F5;
		.dateName{
			margin-right: 20px;
			font-weight: bold;
			margin-left: 20px;
		}
		.dateItem{
			display: flex;
			align-items: center;
			div{
				margin-right: 20px;
			}
		}
	}
	.dateView:nth-child(even){
		background: #F5F5F5;
	}
</style>
